let BufferFactory = ($injector, $log) => {
  'ngInject'

  /** Holds all the requests, so they can be re-requested in future. */
  let buffer = []

  /** Service initialized later because of circular dependency problem. */
  let $http

  /**
   * Appends HTTP request configuration object with promise response attached to buffer.
   * @return {Number} The new length of the buffer.
   */
  let append = (config, promise) => {
    $log.debug('append', config)
    return buffer.push({
      config: config,
      promise: promise
    })
  }

  /**
   * Abandon or reject all the buffered requests.
   */
  let rejectAll = (reason) => {
    $log.debug('rejectAll', reason)
    return Promise.all(buffer.map((buf) => {
      $log.debug('reject', buf)
      return buf.promise.reject(reason)
    })).then(() => {
      $log.debug('rejectAll: cleaning buffer')
      buffer = []
    })
  }

  /**
   * Retries all the buffered requests clears the buffer.
   */
  let retryAll = () => {
    $log.debug('retryAll')
    return Promise.all(buffer.map((buf) => {
      $log.debug('retry', buf)
      $http = $http || $injector.get('$http')
      return $http(buf.config)
      .then(buf.promise.resolve, buf.promise.reject)
    })).then(() => {
      $log.debug('retryAll: cleaning buffer')
      buffer = []
    })
  }

  return { append, rejectAll, retryAll }
}

export default BufferFactory



// WEBPACK FOOTER //
// ./src/app/services/common/buffer.factory.js